export default "__VITE_ASSET__4icIPdCq__"